import { LINK_API_BASE_URL } from "constants/urls";
import { callApi } from "utils/_base";

export const getProfile = () => {
  const route = LINK_API_BASE_URL + `/user/`;
  return callApi("GET", route);
};

export const getUserBalance = () => {
  const route = LINK_API_BASE_URL + `/user/balance/`;
  return callApi("GET", route);
};
